import { TweenLite, TimelineLite, Power0, Power2, Power3 } from 'gsap'
import AnimatedComponent from './AnimatedComponent'

class FullscreenSlideshow extends AnimatedComponent {
  constructor ($el) {
    super($el, {}, $el.width() / 1400)
    this.$el = $el
    this.isPaused = false
    this.index = 0
    this.slidesCount = $el.find('.image').length
    this.autoplayInterval = null
    this.$navigation = $el.find('.fullscreen-slideshow__nav')
    this.isAnimating = false
    this.timeline = new TimelineLite({
      onComplete: () => {
        this.isAnimating = false
      },
    })

    this.$navigation.on('click', 'li', (event) => {
      const $bullet = $(event.target)
      if ($bullet.hasClass('active') || this.isAnimating) {
        return
      }
      const index = this.$navigation.find('li').index(event.target)
      const $preview = this.$el.find('.preview').eq(index)
      TweenLite.to($preview, 0.2, { autoAlpha: 0, ease: Power0.easeNone })
      this.select(index)
    })

    this.$navigation
      .add('.fullscreen-slideshow__title')
      .hover(
        () => {
          this.isPaused = true
        },
        () => {
          this.isPaused = false
        }
      )

    $('body').on('siteMenuToggle', (event, show) => {
      this.isPaused = show
    })

    this.$navigation.find('li').hover(
      (event) => {
        const $bullet = $(event.target)
        if ($bullet.hasClass('active')) {
          return
        }
        const index = this.$navigation.find('li').index(event.target)
        const $preview = this.$el.find('.preview').eq(index)
        TweenLite.fromTo($preview, 0.3, { x: '+=60px' }, { x: '0px', ease: Power2.easeOut })
        TweenLite.fromTo($preview, 0.3, { autoAlpha: 0 }, { autoAlpha: 0.2, ease: Power0.easeNone })
      },
      (event) => {
        const index = this.$navigation.find('li').index(event.target)
        const $preview = this.$el.find('.preview').eq(index)
        TweenLite.to($preview, 0.2, { autoAlpha: 0, ease: Power0.easeNone })
      }
    )

    this.initAutoplayInterval()

    $(window).on('blur', () => {
      clearInterval(this.autoplayInterval)
    })

    $(window).on('focus', () => {
      this.initAutoplayInterval()
    })

    if (window.innerWidth < 768) {
      let maxHeight = 0
      this.$el.find('.fullscreen-slideshow__title').each((i, el) => {
        const height = $(el).height()
        if (maxHeight < height) {
          maxHeight = height
        }
      })

      this.$el.find('.fullscreen-slideshow__titles').height(maxHeight)
    }
  }

  initAutoplayInterval () {
    this.autoplayInterval = setInterval(() => {
      if (this.isPaused) {
        return
      }
      const index = this.index + 1 <= this.slidesCount - 1 ? this.index + 1 : 0
      this.select(index)
    }, 5000)
  }

  select (index) {
    const $currentImage = this.$el.find('.image.active')
    const $nextImage = this.$el.find('.image').eq(index)
    const $currentTitle = this.$el.find('.fullscreen-slideshow__title.active')
    const $nextTitle = this.$el.find('.fullscreen-slideshow__title').eq(index)
    this.isAnimating = true
    this.timeline.timeScale(0.9)
    this.timeline
      .clear()
      .fromTo($currentImage, 1, { x: '0%' }, { x: '-100%', ease: Power3.easeInOut }, 0)
      .fromTo($currentImage.find('.bg'), 1, { x: '0%' }, { x: '80%', ease: Power3.easeInOut }, 0)
      .fromTo($currentImage.find('.bg'), 0.6, { autoAlpha: 1 }, { autoAlpha: 0, ease: Power0.easeNone }, 0.4)
      .fromTo($nextImage, 1, { x: '100%' }, { x: '0%', ease: Power3.easeInOut }, 0)
      .fromTo($nextImage.find('.bg'), 1, { x: '-80%' }, { x: '0%', ease: Power3.easeInOut }, 0)
      .fromTo($nextImage.find('.bg'), 0.6, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone }, 0)
      .fromTo($currentTitle, 0.3, { y: '0px' }, { y: '-30px', ease: Power2.easeIn }, 0)
      .fromTo($currentTitle, 0.3, { autoAlpha: 1 }, { autoAlpha: 0, ease: Power0.easeNone }, 0)
      .fromTo($nextTitle, 0.3, { y: '30px' }, { y: '0px', ease: Power2.easeOut }, 0.3)
      .fromTo($nextTitle, 0.3, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone }, 0.3)

    $currentImage
      .add($nextImage)
      .add($currentTitle)
      .add($nextTitle)
      .toggleClass('active')

    this.index = index
    this.$navigation
      .find('li')
      .removeClass('active')
      .eq(index)
      .addClass('active')
  }

  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .fromTo(
        $el.find('.fullscreen-slideshow__title').first(),
        0.4,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.6
      )
      .fromTo(
        $el.find('.fullscreen-slideshow__fill'),
        this.d,
        { x: '-100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .add('fillVisible')
      .fromTo(
        $el.find('.fullscreen-slideshow__images'),
        this.d,
        { x: '-100%' },
        { x: '0%', ease: Power3.easeInOut },
        `fillVisible-=${this.d / 1.5}`
      )
      .fromTo(
        $el.find('.image').first(),
        this.d,
        { x: '100%' },
        { x: '0%', ease: Power3.easeInOut },
        `fillVisible-=${this.d / 1.5}`
      )
      .staggerFromTo(
        $el.find('.fullscreen-slideshow__nav .scroll-down'),
        0.4,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.2
      )
  }
}

export default FullscreenSlideshow



// WEBPACK FOOTER //
// ./scripts/components/FullscreenSlideshow.js